import NutritionalSR from 'libs/shared/ui/src/lib/components/my-evolution/nutritional/nutritional'

export const Nutrition = () => {
  return (
    <>
      <NutritionalSR />
    </>
  )
}
